import { render, staticRenderFns } from "./MovementPivot.vue?vue&type=template&id=0a5b312f&scoped=true&"
import script from "./MovementPivot.vue?vue&type=script&lang=js&"
export * from "./MovementPivot.vue?vue&type=script&lang=js&"
import style0 from "./MovementPivot.vue?vue&type=style&index=0&id=0a5b312f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a5b312f",
  null
  
)

export default component.exports